function importAll(r) {
    return r.keys().map(r);
}

const equipmentImages = importAll(require.context('./media/equipment', true, /\.(png|jpe?g|webp)$/));

const equipmentText = [
  { name: `Dutch oven` }, 
  { name: `Food processor`, note: `or blender` }, 
  { name: `Baking sheet` },
  { name: `Spray bottle`},
  { name: `Pastry brush` }
]

export const equipment = equipmentText.map((item, index) => {
    return {
        name: item.name,
        note: item.note, 
        img: equipmentImages[index]
    }
})